import { LoadingContainer, ModelViewer } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useInternalObligationsGetAll } from 'core/types'

const LoanObligations = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: obligations,
    isLoading,
    error,
  } = useInternalObligationsGetAll({
    companyId,
    personId,
    loanId,
  })

  return (
    <LoadingContainer error={error} loading={isLoading}>
      <Page variant='full'>
        <ModelViewer json={obligations} />
      </Page>
    </LoadingContainer>
  )
}

export default LoanObligations
